import mapboxgl from 'mapbox-gl'
import MapboxGeocoder from "@mapbox/mapbox-gl-geocoder"

export default {
    props: {
        hasMarker: {
            type: Boolean,
            default: false
        },
        markerCoordinates: {
            type: Array,
            default: function () {
                return [135, 35]
            }
        },
        draggable: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            myMarker: null
        }
    },
    methods: {
        handleMarker() {
            if (!this.hasMarker) return;
            if (this.myMarker) {
                this.removeMarker()
            }
            this.myMarker = new mapboxgl.Marker({
                draggable: this.draggable
            })
                .setLngLat(this.markerCoordinates)
                .addTo(this.mySmartMap)

            this.myMarker.on('dragend', this.onDragEnd)

        },
        onDragEnd() {
            var lnglat = this.myMarker.getLngLat();
            this.$emit('updatedMarkerCoordinates', [lnglat.lng, lnglat.lat])
        },
        removeMarker() {
            this.myMarker.remove()
        },
        queryLocation(address) {
            let self = this
            let geocoder = new MapboxGeocoder({
                accessToken: mapboxgl.accessToken,
                mapboxgl: mapboxgl,
            });
            geocoder.addTo('#geocoder-container')
            geocoder.query(address)

            geocoder.on('result', function (result) {
                self.$emit('updatedMarkerCoordinates', result.result.center)
                self.setFlyToForMarker(result.result.center)
            })
        },
        setFlyToForMarker(val) {
            this.mySmartMap.flyTo({
                center: val,
                speed: 1.8
            })
        }
    },
    watch: {
        hasMarker() {
            this.handleMarker()
        },
        draggable(newVal) {
            this.myMarker.setDraggable(newVal)
        },
        markerCoordinates(newVal) {
            if (!this.myMarker) {
                this.handleMarker()
            } else {
                this.myMarker.setLngLat(newVal)
            }
        }
    }
}